// =============================================================================
// src/features/analytics/index.ts — Barrel da feature Analytics.
// =============================================================================

import type { AppContext } from '../../app/types';
import { rehydrateAnalyticsLive } from '../analytics-live-hydrate';
import { AnalyticsRoute } from './analytics-route';
import {
  activeAnalyticsModuleName,
  initAnalyticsInteractions,
  refreshAnalyticsFeedPage,
} from './analytics-controller';
import { bindAnalyticsInsightEditionNav } from './analytics-insights-nav-controller';
import { analyticsLiveSource } from './analytics-live-store';
import { rerenderAnalyticsPage, setAnalyticsPageBusy } from './analytics-rerender';
import { setAnalyticsViewChangeHandler } from './analytics-view-state';

export { buildAnalyticsPageMarkup } from './analytics-markup';
export { AnalyticsRoute } from './analytics-route';

interface AnalyticsPublishWindow {
  AnalyticsRoute?: typeof AnalyticsRoute;
}

/**
 * Inicializa Analytics: publica singleton, resolve a pagina e liga controles.
 *
 * @example
 *   initAnalytics(context);
 */
export function initAnalytics(_ctx: AppContext): void {
  publishAnalyticsGlobals();
  AnalyticsRoute.init();
  initAnalyticsInteractions();
  // Resumo de IA (2026-07-28): prev/next das edicoes vivas dos Cards Taticos.
  bindAnalyticsInsightEditionNav();
  // 2026-09-02: escopo/periodo/reacoes re-hidratam no servidor e remontam a rota.
  setAnalyticsViewChangeHandler(handleAnalyticsViewChange);
  // 2026-09-20: primeira pagina do feed. SEM esta chamada a lista ao vivo nasce
  // vazia — assim que o loader existe, analyticsListedMentions() passa a ler a
  // pagina servida em vez da selecao curada. `true` = buscar tambem a contagem.
  void refreshAnalyticsFeedPage(1, true);
}

function publishAnalyticsGlobals(): void {
  (window as unknown as AnalyticsPublishWindow).AnalyticsRoute = AnalyticsRoute;
}

/** Re-hidrata para o recorte novo e remonta a pagina no modulo em que o operador estava. */
export async function handleAnalyticsViewChange(): Promise<void> {
  const activeModule = activeAnalyticsModuleName();
  setAnalyticsPageBusy(true);
  try {
    const status = await rehydrateAnalyticsLive();
    // Estava ao vivo e o Hasura nao respondeu: nao remonta com o store limpo.
    if (status.reason === 'fetch_failed') throw new Error('analytics: recorte nao carregou');
  } finally {
    setAnalyticsPageBusy(false);
  }
  if (analyticsLiveSource() === 'static') return;
  rerenderAnalyticsPage(() => {
    initAnalyticsInteractions(activeModule);
    bindAnalyticsInsightEditionNav();
  });
  // Recorte novo = conjunto novo: a pagina volta a 1 e a contagem e refeita.
  await refreshAnalyticsFeedPage(1, true);
}
